// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__RAsdB","idioms":"Footer_idioms__3bQc1","hr":"Footer_hr__VTUcH","end":"Footer_end__kS-us","back-to-top":"Footer_back-to-top__WuqrT"};